<template>
  <!-- Begin Page Content -->
  <div class="container">
    <!-- Page Heading -->
    <div class="d-sm-flex align-items-center justify-content-between mb-4">
      <h1 class="h3 mb-0 text-gray-800">Selbeg.MN</h1>
    </div>

    <div class="row justify-content-center">
      <div class="col col-md-3 col-sm-6 my-3"  v-for="category in categories" :key="category.id">
        <div class="card"  style="cursor:pointer;" @click="$router.push({ name:'CategoryItems', params:{ categoryId: category.id } })" >
          <img class="card-img-top" style="height:90px; width:90px" :src="_getImage(category)" alt="">
          <div class="card-body">
            <p class="card-text">{{category.name}}</p>
          </div>
        </div>
      </div>
    </div>
    <hr/>

    <div class="row">
      <div class="col col-12">
        <button class="btn btn-sm btn-block btn-secondary" @click="$router.push({name:'FilterByCartype'})">Машин сонгох</button>
      </div>
      
    </div>
    
    <hr/>
    <div class="row justify-content-center">
      <div class="col col-md-3 col-sm-6 my-3"  v-for="store in stores">
        <div class="card"  style="cursor:pointer;" v-bind:class="[store && store.pin==true ? 'border border-success':'']" @click="$router.push({ name:'StoreItems', params:{ storeId: store.id } })">
          <div class="card-body">
            <p class="card-text">{{store.name}}</p>
          </div>
        </div>
      </div>
    </div>

  </div>
  <!-- /.container-fluid -->
</template>

<script>
const fb = require('../firebaseConfig.js');
import Vue from 'vue';
import { mapState } from 'vuex';
import firebase from 'firebase';
export default {
  name: "Dashboard",
  data() {
    return {
      categories:[],
      stores:[]
    };
  },
  methods: {
    getCategories(){
      fb.db.collection("selbegtypes").orderBy("createdAt").get().then(docs=>{
        if(docs && !docs.empty){
          this.categories=[];
          docs.docs.forEach(value=>{
            if(value && value.exists){
              let item=value.data();
              item.id=value.id;
              this.categories.push(item);
            }
          });
        }
      })
    },
    getStores(){
      var fff = firebase.functions().httpsCallable('homeStores');
      fff() .then((result) => {
          if(result && result.data && result.data.length>0){
            this.stores=result.data;
          }
      });
    },
    _getImage(obj) {
      if (obj.images != null && obj.images != undefined) {

        return obj.images[0]["fileUrl"];
      }
      return null;
    },
  },
  created(){
    this.getCategories();
    this.getStores();
  }
};
</script>

